// src/data/mockData.js

export const mockData = {
    // ===================================
    // DATOS AGREGADOS DEL AÑO 2024
    // ===================================
    2024: {
        // 1. Lista de Productores activos en el 2024 (7 en total)
        productoresIndex: [
            { id: '1', userPk: '1', nombre: 'Prod 1' },
            { id: '2', userPk: '2', nombre: 'Prod 2' },
            { id: '3', userPk: '3', nombre: 'Prod 3' },
            { id: '4', userPk: '4', nombre: 'Prod 4' },
            { id: '5', userPk: '5', nombre: 'Prod 5' },
            { id: '6', userPk: '6', nombre: 'Prod 6' },
            { id: '7', userPk: '7', nombre: 'Prod 7' }
        ],
        // 2. Resultados Generales (Los que usan CaracterizacionView, RatingView, etc.)
        resultados: {
            totalProduccion: 252.4, // de '252,4' (TON)
            totalAgua: 48084, // de '48.084' (M3)
            superficie: {
                "<1ha": 60.00, // de '60,00%'
                "1-3.9ha": 33.33, // de '33,33%'
                "4-6ha": 0.00,
                "10-12.9ha": 6.67 // de '6,67%'
            },
            genero: {
                mujeres: 4, // de chartSeries[0]
                hombres: 3 // de chartSeries[1]
            },
            // DATOS EXTRAÍDOS DE top-panel-2 y top-panel-3
            tipoEmpresa: {
                juridica: 1,
                natural: 6
            },
            microempresa: {
                porcentaje: 100, // de '100%'
                rangoUF: '0 - 2400 UF'
            },
            propiedad: {
                propietario: 3,
                arrendatario: 3,
                comodato: 1,
                categorias: ["Propiedad"]
            },
            rating: {
                image: require('@/media/rating/E.png')
            },
            materiaPrima: {
                chartSeries: [2247.9, 622.2],  // Materia Prima vs Residuos
                gestionResiduos: 'A veces',
                reciclaje: '51-75%',
                compostaje: '51-75%',
                nota: 'Los productos: dátil, limón, maíz y tomate aún no son materias primas...'
            }

        },
        // 3. Resultados Generales (Usados por TreeMap)
        productos: [
            { option: 'Pimiento', cant: 80, producto: 'Pimiento', pertinencia: 'Alta', practica: 'Tecnificada', sellos: 'No tiene', produccion: '80 Ton' },
            { option: 'Ají', cant: 60, producto: 'Ají', pertinencia: 'Media', practica: 'Tecnificada', sellos: 'No tiene', produccion: '60 Ton' },
            { option: 'Dátil', cant: 40, producto: 'Dátil', pertinencia: 'Baja', practica: 'Tecnificada', sellos: 'No tiene', produccion: '40 Ton' },
            { option: 'Tomate', cant: 36, producto: 'Tomate', pertinencia: 'Alta', practica: 'Tecnificada', sellos: 'No tiene', produccion: '36 Ton' },
            { option: 'Aceituna', cant: 10.01, producto: "Aceituna", pertinencia: "Alta", practica: "Tecnificada", sellos: "I. Geográfica", produccion: '10 Ton' },
            { option: 'Tomate Cherry', cant: 10, producto: 'Tomate Cherry', pertinencia: 'Media', practica: 'Tecnificada', sellos: 'No tiene', produccion: '10 Ton' },
            { option: 'Maíz', cant: 5, producto: 'Maíz', pertinencia: 'Alta', practica: 'Campesina', sellos: 'I. Geográfica', produccion: '5 Ton' },
            { option: 'Albahaca', cant: 3, producto: 'Albahaca', pertinencia: 'Baja', practica: 'Tecnificada', sellos: 'No tiene', produccion: '3 Ton' },
            { option: 'Maracuyá', cant: 1.8, producto: 'Maracuyá', pertinencia: 'Baja', practica: 'Campesina', sellos: 'No tiene', produccion: '1,8 Ton' },
            { option: 'Guayaba', cant: 1.4, producto: 'Guayaba', pertinencia: 'Baja', practica: 'Campesina', sellos: 'No tiene', produccion: '1,4 Ton' },
            { option: 'Limón', cant: 1.2, producto: 'Limón', pertinencia: 'Baja', practica: 'Campesina', sellos: 'No tiene', produccion: '1,2 Ton' },
            { option: 'Pepino', cant: 1, producto: 'Pepino', pertinencia: 'Baja', practica: 'Tecnificada', sellos: 'No tiene', produccion: '1 Ton' },
            { option: 'Orégano', cant: 1, producto: 'Orégano', pertinencia: 'Alta', practica: 'Campesina', sellos: 'I. Geográfica, M. Campesinas', produccion: '1 Ton' },
            { option: 'Berenjena', cant: 1, producto: 'Berenjena', pertinencia: 'Baja', practica: 'Tecnificada', sellos: 'No tiene', produccion: '1 Ton' },
            { option: 'Ajo', cant: 1, producto: 'Ajo', pertinencia: 'Alta', practica: 'Campesina', sellos: 'No tiene', produccion: '1 Ton' },
        ],
        // RESULTADOS GENERALES
        ubicacion: {
            // DATOS EXTRAÍDOS DEL data_regiones
            regiones: [
                {
                    numero_region: 1,
                    nombre: "Tarapacá",
                    coordinates: [-69.4115587, -19.1895282],
                    color_region: "#EB8180"
                },
                {
                    numero_region: 15,
                    nombre: "Arica y Parinacota",
                    coordinates: [-69.4115587, -19.1895282],
                    color_region: "#F28C28"
                },
            ],
            // DATOS EXTRAÍDOS DEL data_comunas (Productor individual)
            productores: [
                {
                    productor: 'Prod 1',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Azapa',
                    distancia_arica: '8.5 Km',
                    productos: ['Aceituna', 'Albahaca', 'Berenjena', 'Pepino'],
                    coordinates: [-70.209529, -18.507798]
                },
                {
                    productor: 'Prod 2',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Azapa',
                    distancia_arica: '45.0 Km',
                    productos: ['Ají', 'Pimiento', 'Tomate', 'Tomate Cherry'],
                    coordinates: [-69.8886099, -18.582377]
                },
                {
                    productor: 'Prod 3',
                    region: 'Tarapacá',
                    ubicacion: 'Nama',
                    distancia_arica: '285.0 Km',
                    productos: ['Ajo'],
                    coordinates: [-69.4115587, -19.1895282]
                },
                {
                    productor: 'Prod 4',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Villa Frontera',
                    distancia_arica: '12.0 Km',
                    productos: ['Dátil'],
                    coordinates: [-70.3075036, -18.4041655]
                },
                {
                    productor: 'Prod 5',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Pampa Concordia',
                    distancia_arica: '16.0 Km',
                    productos: ['Guayaba', 'Limón', 'Maracuyá'],
                    coordinates: [-70.3031824, -18.3578823]
                },
                {
                    productor: 'Prod 6',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Valle de Lluta',
                    distancia_arica: '57.0 Km',
                    productos: ['Maíz'],
                    coordinates: [-69.9458826, -18.3819138]
                },
                {
                    productor: 'Prod 7',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Socoroma',
                    distancia_arica: '124.0 Km',
                    productos: ['Orégano'],
                    coordinates: [-69.5977, -18.2639723]
                },
            ]
        },
        // RESULTADOS GENERALES en KG
        materiaprima: {
            sankey: {
                nodes: [
                    { id: 'Materia Prima', title: 'Materia Prima' },
                    { id: 'Aceituna', title: 'Aceituna' },
                    { id: 'Ají', title: 'Ají' },
                    { id: 'Ajo', title: 'Ajo' },
                    { id: 'Albahaca', title: 'Albahaca' },
                    { id: 'Berenjena', title: 'Berenjena' },
                    { id: 'Maracuyá', title: 'Maracuyá' },
                    { id: 'Guayaba', title: 'Guayaba' },
                    { id: 'Orégano', title: 'Orégano' },
                    { id: 'Pepino', title: 'Pepino' },
                    { id: 'Pimiento', title: 'Pimiento' },
                    { id: 'Tomate Cherry', title: 'Tomate Cherry' },
                    { id: 'Residuos Orgánicos', title: 'Residuos Orgánicos' }
                ],
                links: [
                    { source: 'Materia Prima', target: 'Aceituna', value: 929.3 },
                    { source: 'Materia Prima', target: 'Ají', value: 100.6 },
                    { source: 'Materia Prima', target: 'Ajo', value: 165.9 },
                    { source: 'Materia Prima', target: 'Albahaca', value: 219 },
                    { source: 'Materia Prima', target: 'Berenjena', value: 153.6 },
                    { source: 'Materia Prima', target: 'Maracuyá', value: 226.9 },
                    { source: 'Materia Prima', target: 'Guayaba', value: 446.7 },
                    { source: 'Materia Prima', target: 'Orégano', value: 1.7 },
                    { source: 'Materia Prima', target: 'Pepino', value: 133.7 },
                    { source: 'Materia Prima', target: 'Pimiento', value: 323.3 },
                    { source: 'Materia Prima', target: 'Tomate Cherry', value: 169.3 },
                    { source: 'Aceituna', target: 'Residuos Orgánicos', value: 185.8 },
                    { source: 'Ají', target: 'Residuos Orgánicos', value: 13.6 },
                    { source: 'Ajo', target: 'Residuos Orgánicos', value: 3.3 },
                    { source: 'Albahaca', target: 'Residuos Orgánicos', value: 120.4 },
                    { source: 'Berenjena', target: 'Residuos Orgánicos', value: 38.5 },
                    { source: 'Maracuyá', target: 'Residuos Orgánicos', value: 90.7 },
                    { source: 'Guayaba', target: 'Residuos Orgánicos', value: 53.6 },
                    { source: 'Orégano', target: 'Residuos Orgánicos', value: 0.0 },
                    { source: 'Pepino', target: 'Residuos Orgánicos', value: 7.2 },
                    { source: 'Pimiento', target: 'Residuos Orgánicos', value: 106.6 },
                    { source: 'Tomate Cherry', target: 'Residuos Orgánicos', value: 2.5 }
                ]
            }
        }
    },
    // ===================================
    // DATOS AGREGADOS DEL AÑO 2025 (Mock)
    // ===================================
    2025: {
        // 1. Lista de Productores activos en el 2025 (SOLO 2)
        productoresIndex: [
            { id: '8', userPk: '1', nombre: 'Prod 1' },
            { id: '9', userPk: '7', nombre: 'Prod 7' }
        ],
        // RESULTADOS GENERALES
        resultados: {
            // DATOS EXTRAÍDOS DE InfoCardDoble, InfoCardTriple y DonutChart
            totalProduccion: 9,   // (TON) CARACTERIZACION - VCARD PRODUCCION ANUAL
            totalAgua: 9372,       // (M3)  CARACTERIZACION - VCARD CONSUMO AGUA ANUAL
            superficie: {           // PENDIENTE !!!!!! CARACTERIZACION - VCARD RAGO SUPERFICIE CULTIVADA 
                "<1ha": 25.00,
                "1-3.9ha": 50.00,
                "4-6ha": 25.00,
                "10-12.9ha": 0.00
            },
            genero: {        // CARACTERIZACION - VCARD PRODUCTORES PARTICIPANTES
                mujeres: 2,  // de chartSeries[0]  
                hombres: 0   // de chartSeries[1]
            },
            // DATOS EXTRAÍDOS DE top-panel-2 y top-panel-3
            tipoEmpresa: {   // CARACTERIZACION - VCARD TIPO EMPRESA
                juridica: 0,
                natural: 2
            },
            microempresa: {             // CARACTERIZACION { VCARD TAMAÑO EMPRESA
                porcentaje: 100,        // de '100%'
                rangoUF: '0 - 2400 UF'
            },
            propiedad: {                // CARACTERIZACION - VCARD PROPIEDAD
                propietario: 2,
                arrendatario: 0,
                comodato: 0,
                categorias: ["Propiedad"]
            },
            rating: {                   // RATING - VCARD PROPIEDAD
                image: require('@/media/rating/D.png')
            },
            materiaPrima: {             // MATERIA PRIMA - VCARD Materias primas y residuos orgánicos DE LA EMPRESA:
                chartSeries: [885.33, 2902.90],  // Materia Prima vs Residuos
                gestionResiduos: 'Siempre',
                reciclaje: '51-75%',
                compostaje: '76-100%',
                nota: 'En 2025 los productos como la aceituna y berenjena, junto a la Albahaca corresponden a la principal materia prima base.'
            }
        },
        // RESULTADOS GENERALES - CARACTERIZACION - VCARD PRODUCTOS TREEMAP CUADRO EMERGENTE
        // DATOS EXTRAÍDOS DEL maptreeData (InfoCardTreeMap)
        productos: [
            { option: 'Aceituna', cant: 6, producto: "Aceituna", pertinencia: "Alta", practica: "Campesina", sellos: "I. Geográfica", produccion: '6 Ton' },
            { option: 'Albahaca', cant: 1, producto: 'Albahaca', pertinencia: 'Baja', practica: 'Campesina', sellos: 'No tiene', produccion: '1 Ton' },
            { option: 'Berenjena', cant: 1, producto: 'Berenjena', pertinencia: 'Baja', practica: 'Campesina', sellos: 'No tiene', produccion: '1 Ton' },
            { option: 'Orégano', cant: 1, producto: 'Orégano', pertinencia: 'Alta', practica: 'Campesina', sellos: 'I. Geográfica, M. Campesinas', produccion: '1 Ton' },

        ],
        // RESULTADOS GENERALES - CARACTERIZACION - MAPA
        ubicacion: {
            // DATOS EXTRAÍDOS DEL data_regiones
            regiones: [
                {
                    numero_region: 1,
                    nombre: "Tarapacá",
                    coordinates: [-69.4115587, -19.1895282],
                    color_region: "#EB8180"
                },
                {
                    numero_region: 15,
                    nombre: "Arica y Parinacota",
                    coordinates: [-69.4115587, -19.1895282],
                    color_region: "#F28C28"
                },
            ],
            // RESULTADOS GENERALES - CARACTERIZACION - VCARD MAPA CUADRO EMERGENTE
            // DATOS EXTRAÍDOS DEL data_comunas (Productor individual)
            productores: [
                {
                    productor: 'Prod 1',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Azapa',
                    distancia_arica: '8.5 Km',
                    productos: ['Aceituna', 'Albahaca', 'Berenjena'],
                    coordinates: [-70.209529, -18.507798]
                },
                {
                    productor: 'Prod 7',
                    region: 'Arica y Parinacota',
                    ubicacion: 'Socoroma',
                    distancia_arica: '124.0 Km',
                    productos: ['Orégano'],
                    coordinates: [-69.5977, -18.2639723]
                }
            ]
        },

        // MATERIA PRIMA : RESULTADOS GENERALES en KG para Sankey
        materiaprima: {
            sankey: {
                nodes: [
                    { id: 'Materia Prima', title: 'Materia Prima' },
                    { id: 'Aceituna', title: 'Aceituna' },
                    { id: 'Albahaca', title: 'Albahaca' },
                    { id: 'Berenjena', title: 'Berenjena' },
                    { id: 'Orégano', title: 'Orégano' },
                    { id: 'Residuos Orgánicos', title: 'Residuos Orgánicos' }
                ],
                links: [
                    { source: 'Materia Prima', target: 'Aceituna', value: 1493.7 },
                    { source: 'Materia Prima', target: 'Albahaca', value: 166.2 },
                    { source: 'Materia Prima', target: 'Berenjena', value: 1241.1 },
                    { source: 'Materia Prima', target: 'Orégano', value: 1.9 },
                    { source: 'Aceituna', target: 'Residuos Orgánicos', value: 335.5 },
                    { source: 'Albahaca', target: 'Residuos Orgánicos', value: 84.6 },
                    { source: 'Berenjena', target: 'Residuos Orgánicos', value: 465.2 },
                    { source: 'Orégano', target: 'Residuos Orgánicos', value: 0.03 }
                ]
            }
        }
    }
};
